

    import { defineComponent } from 'vue'
    import Container from '../components/Container.vue'
    import Grid from '../components/Grid/Grid.vue'
    import Column from '../components/Grid/Column.vue'
    import PageHeader from '../components/PageHeader.vue'
    import Picture from '../components/Picture.vue'
    import BlogContent from '../components/Blog/BlogContent.vue'
    import MetaInfo from '../components/MetaInfo.vue'
    import ThemeChanger from '../components/ThemeChanger.vue'
    import { Theme } from '../enums/Theme'
    import { Route } from '../enums/Route'
    import { useCms } from '../compositions/UseCms'
    import { useTheme } from '../compositions/UseTheme'
    import { useRoute } from 'vue-router'
    import { useBlogType } from '../compositions/UseBlogType'
    import Paragraph from '../components/Paragraph.vue'

    export default defineComponent({
        name: 'BlogPost',
        components: {
            Paragraph,
            Container,
            Grid,
            Column,
            BlogContent,
            PageHeader,
            Picture,
            MetaInfo,
            ThemeChanger
        },
        beforeRouteEnter(to, from, next) {

            useCms().blogData(to.params.slug as string) ? next() : next({ name: Route.NotFound })

        },
        setup() {

            const route = useRoute()
            const { blogData } = useCms()
            const post = blogData(route.params.slug)

            const { isNormalBlogPost, isShareBlogPost } = useBlogType()
            useTheme().initializeCurrentThemeBasedOnRouteMeta()

            return {
                Theme,
                post,
                isNormalBlogPost,
                isShareBlogPost
            }

        }
    })

